import React from 'react'
import Cropper from 'cropperjs';
import { Portal } from 'react-portal';

const MapZoom = () => {

let cropper;

const image = document.getElementById('dewitt-map-zoom');

 cropper = new Cropper(image.firstChild,{
  checkOrientation:false,
  checkCrossOrigin: false,
  autoCrop: false,
  restore: false,
  scalable: false,
  rotatable:false,
  modal:false,
  guides: false,
  highlight:false,
  cropBoxMovable:false,
  cropBoxResizable:false,
  dragMode:'move',
  toggleDragModeOnDblclick: false,
  background:false,
  movable:true,
  center:true,
  wheelZoomRatio:.5,
  viewMode:3,
  aspectRatio: 1,
});

cropper.enable()


  return (
    <Portal node={document && image}> 
    <div className="zoom-button-container">
	<a className="child-theme-button child-theme-button-primary-color zoom-button" onClick={(e)=> cropper.zoom(.5)}>Zoom In</a>
    <a className="child-theme-button child-theme-button-primary-color zoom-button" onClick={(e)=> cropper.zoom(-.5)}>Zoom Out</a>
      </div>
  </Portal>

  )
}

export default MapZoom;
